import { io, Socket } from 'socket.io-client';
import { ClientToServerEvents, ServerToClientEvents } from '../types/socket';

class SocketService {
  private static instance: SocketService;
  private socket: Socket<ServerToClientEvents, ClientToServerEvents> | null = null;

  private constructor() {}

  public static getInstance(): SocketService {
    if (!SocketService.instance) {
      SocketService.instance = new SocketService();
    }
    return SocketService.instance;
  }

  public connect(): void {
    if (!this.socket) {
      this.socket = io(import.meta.env.VITE_SOCKET_URL, {
        autoConnect: false,
        reconnection: true,
        transports: ['websocket'],
      });

      this.socket.on('connect_error', (error) => {
        console.error('Socket connection error:', error);
      });
    } else if (this.socket.connected) {
      this.socket.disconnect;
    }

    this.socket.connect();
  }

  public disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  public getSocket(): Socket<ServerToClientEvents, ClientToServerEvents> | null {
    return this.socket;
  }
}

export default SocketService;